export default "__VITE_ASSET__xhokW4Cx__"